export default __webpack_public_path__ + "static/media/random5.4dd3eb45.jpeg";